import {createMultiPathSVG} from './TEMPLATE'

// phosphor: house-fill (fill weight)
export const HomeOpen_Filled_Corner0_Rounded = createMultiPathSVG({
  paths: [
    'M224,120v96a8,8,0,0,1-8,8H160a8,8,0,0,1-8-8V164a4,4,0,0,0-4-4H108a4,4,0,0,0-4,4v52a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V120a16,16,0,0,1,4.69-11.31l80-80a16,16,0,0,1,22.62,0l80,80A16,16,0,0,1,224,120Z',
  ],
  viewBox: '0 0 256 256',
})

// phosphor: house
export const HomeOpen_Stoke2_Corner0_Rounded = createMultiPathSVG({
  paths: [
    'M219.31,108.68l-80-80a16,16,0,0,0-22.62,0l-80,80A15.87,15.87,0,0,0,32,120v96a8,8,0,0,0,8,8h64a8,8,0,0,0,8-8V160h32v56a8,8,0,0,0,8,8h64a8,8,0,0,0,8-8V120A15.87,15.87,0,0,0,219.31,108.68ZM208,208H160V152a8,8,0,0,0-8-8H104a8,8,0,0,0-8,8v56H48V120l80-80,80,80Z',
  ],
  viewBox: '0 0 256 256',
})
